import React from "react";
import { Link } from "react-router-dom";

interface ServiceProps {
    data: any;
    isLoading: boolean;
}

const ServiceCard: React.FC<ServiceProps> = (props) => {
    return (
        <>
            <div className="col-md-3">
                <div className="row columns_margin_bottom_40 services-row">
                    <div className="col-sm-12 col-xs-6">
                        <div className="teaser">
                            <div className="main_bg_color2 size_normal round overlapped-icon">
                                <i className="rt-icon2-file-pdf-o highlight" />
                            </div>
                            <h4 className="text-uppercase">
                                <Link to={props.data?.url}>{props.data?.title}</Link>
                            </h4>
                            <hr className="divider_2_30 left main_bg_color" />
                            <p>
                                <Link target="_blank" to={props.data?.dosya} className="theme_button color2">Dosyayı Görüntüle</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceCard;